// Requests in flight, by key. Several containers on one page ask for the same data when they mount
// (the overview has one per card); while a request is running they share it instead of each starting
// their own before the first answer is stored. Once it finishes, the next caller starts a fresh one.
const inFlight = new Map()

/**
 * @param {string} key what is being requested, e.g. "regions" or "pricing:EUR"
 * @param {() => Promise} start starts the request when none is running for the key
 * @returns {Promise} the running request
 */
export const shareInFlight = (key, start) => {
  if (!inFlight.has(key)) {
    inFlight.set(key, start().finally(() => inFlight.delete(key)))
  }
  return inFlight.get(key)
}
